import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Small } from 'foundations-components/transitional/components/Small';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { UpgradeIcon } from 'foundations-assets/icons/components/UpgradeIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const NotificationStatusTag = ({
  statusText,
  underline = true
}) => {
  if (!statusText) {
    return null;
  }
  return /*#__PURE__*/_jsxs(TFlex, {
    gap: 6,
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(IconHolder, {
      paddingInline: "0",
      size: "100",
      icon: UpgradeIcon
    }), /*#__PURE__*/_jsx(Small, {
      color: "text-core-subtle",
      textDecoration: underline ? 'underline' : 'none',
      children: statusText
    })]
  });
};